export const required = {
  presence: {
    allowEmpty: false,
    message: 'is required',
  },
}
